import {FC, KeyboardEvent} from 'react'
import {GetListParams} from '../../../../../../services/cellcast.v2.types'
import {KTSVG} from '../../../../../../_metronic/helpers'
import useResponsive from '../../../../../hooks/useResponsive'

export type ListFilterProps = {
  params: GetListParams
  setParams: (p: GetListParams) => void
  doFetch: () => void
}

const ListFilter: FC<ListFilterProps> = ({params, setParams, doFetch}) => {
  const {isMobile} = useResponsive()
  const handleSearchEnter = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      doFetch()
    }
  }

  return (
    <div className='d-flex mt-5 align-items-start position-relative my-1 flex-column flex-sm-row'>
      <div className={`relative ${isMobile ? 'w-100' : ''}`}>
        <KTSVG
          path='/media/icons/duotune/general/gen021.svg'
          className='svg-icon-1 position-absolute ms-6 mt-3'
        />
        <input
          type='text'
          value={params.search ? params.search : ''}
          data-kt-user-table-filter='search'
          className={`form-control form-control-solid ps-14 ${isMobile ? 'w-100' : 'w-250px'}`}
          placeholder='input and press enter'
          onChange={(e: any) => setParams({...params, search: e.target.value, page: 1})}
          onKeyDown={handleSearchEnter}
        />
      </div>
    </div>
  )
}

export default ListFilter
